export default "__VITE_ASSET__Bt47jNtQ__"